/* =====================================================================
   Trelevo · Premium Produktseiten-Module · Variant-Change-Dispatcher
   + Section-Reload-Logik fuer URL-/Variant-Wechsel.

   Stand: 2026-04-29 (Phase A erweitert)
   ===================================================================== */
(function () {
  'use strict';

  if (window.TrelevoPP && window.TrelevoPP._initialized) return;
  window.TrelevoPP = window.TrelevoPP || {};
  window.TrelevoPP._initialized = true;

  // ---------- Helfer ----------
  function detectProductHandle() {
    var el = document.querySelector('[data-tpp-product-handle]');
    if (el && el.getAttribute('data-tpp-product-handle')) return el.getAttribute('data-tpp-product-handle');
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function detectVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
    if (input && input.value) return input.value;
    var params = new URLSearchParams(window.location.search);
    return params.get('variant');
  }

  function fetchVariantData(handle, variantId) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = p.variants.find(function (x) { return String(x.id) === String(variantId); });
        return v ? Object.assign({}, v, { _product: p }) : null;
      });
  }

  function dispatchVariantChange(variant) {
    if (!variant) return;
    document.dispatchEvent(new CustomEvent('trelevo:variant-change', { detail: { variant: variant } }));
  }

  // ---------- Section-Reload via Section Rendering API ----------
  // Refreshe alle Sections mit Attribut data-tpp-reload-on-variant-change
  function refreshReloadableSections(handle, variantId) {
    if (!handle) return;
    var nodes = document.querySelectorAll('[data-tpp-reload-on-variant-change]');
    nodes.forEach(function (sec) {
      var sectionId = sec.getAttribute('data-section-id');
      if (!sectionId) return;
      var url = '/products/' + handle + '?section_id=' + encodeURIComponent(sectionId);
      if (variantId) url += '&variant=' + encodeURIComponent(variantId);
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html.trim();
          // Section Rendering liefert das gerenderte Section-Markup.
          // Wir suchen den ersten Wrapper mit data-tpp-section und
          // ersetzen unsere alte Section damit.
          var newRoot = tmp.querySelector('[data-tpp-section]');
          if (newRoot) {
            sec.replaceWith(newRoot);
          }
        })
        .catch(function (err) {
          console.warn('[TrelevoPP] Section-Reload fehlgeschlagen für', sectionId, err);
        });
    });
  }

  window.TrelevoPP.refreshSections = refreshReloadableSections;

  // ---------- URL-Watcher (für AJAX-Variant-Wechsel) ----------
  var lastUrl = window.location.pathname + window.location.search;
  function checkUrlChange() {
    var current = window.location.pathname + window.location.search;
    if (current !== lastUrl) {
      lastUrl = current;
      var h = detectProductHandle();
      var v = detectVariantId();
      refreshReloadableSections(h, v);
      if (h && v) fetchVariantData(h, v).then(dispatchVariantChange);
    }
  }

  // history.pushState/replaceState patchen, damit AJAX-getriebene URL-Updates erkannt werden
  ['pushState', 'replaceState'].forEach(function (m) {
    var orig = history[m];
    history[m] = function () {
      var ret = orig.apply(this, arguments);
      setTimeout(checkUrlChange, 50);
      return ret;
    };
  });
  window.addEventListener('popstate', function () { setTimeout(checkUrlChange, 50); });

  // Variant-Hidden-Input change (für Produkte mit echten Varianten)
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches) return;
    if (!e.target.matches('input[name="id"], select[name="id"]')) return;
    var handle = detectProductHandle();
    var variantId = e.target.value;
    if (!handle || !variantId) return;
    refreshReloadableSections(handle, variantId);
    fetchVariantData(handle, variantId).then(dispatchVariantChange);
  });

  // Initialer Dispatch beim Page-Load
  document.addEventListener('DOMContentLoaded', function () {
    var handle = detectProductHandle();
    var variantId = detectVariantId();
    if (handle && variantId) fetchVariantData(handle, variantId).then(dispatchVariantChange);
  });

  // Manueller Auslöser fürs Debugging:
  //   TrelevoPP.refresh()
  window.TrelevoPP.refresh = function () {
    var handle = detectProductHandle();
    var variantId = detectVariantId();
    if (handle) refreshReloadableSections(handle, variantId);
    if (handle && variantId) fetchVariantData(handle, variantId).then(dispatchVariantChange);
  };

  // ==========================================================
  //  Toggle-Logik fuer einklappbare Sektionen (mit Gruppen)
  //  Sektionen mit data-tpp-collapsible werden initial versteckt;
  //  Buttons mit data-tpp-toggle-btn klappen sie ein/aus.
  //
  //  Gruppen-Konzept:
  //    data-tpp-collapsible="main"   --> gehoert zur Gruppe 'main'
  //    data-tpp-collapsible (leer)   --> Backwards-Kompat: 'main'
  //    data-tpp-collapsible="extra"  --> Gruppe 'extra'
  //  Buttons mit data-tpp-toggle-btn="GRUPPE" steuern nur ihre Gruppe.
  // ==========================================================
  function normalizeGroup(val) {
    if (!val) return 'main';
    return val;
  }

  function getCollapsiblesForGroup(group) {
    var all = document.querySelectorAll('[data-tpp-collapsible]');
    var out = [];
    all.forEach(function (el) {
      var g = normalizeGroup(el.getAttribute('data-tpp-collapsible'));
      if (g === group) out.push(el);
    });
    return out;
  }

  function getButtonsForGroup(group) {
    var all = document.querySelectorAll('[data-tpp-toggle-btn]');
    var out = [];
    all.forEach(function (btn) {
      var g = normalizeGroup(btn.getAttribute('data-tpp-toggle-btn'));
      if (g === group) out.push(btn);
    });
    return out;
  }

  function setGroupState(group, expanded) {
    getCollapsiblesForGroup(group).forEach(function (el) {
      el.style.display = expanded ? '' : 'none';
    });
    getButtonsForGroup(group).forEach(function (btn) {
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var labelText = expanded ? btn.dataset.textExpanded : btn.dataset.textCollapsed;
      var chevron = btn.querySelector('.tpp-toggle__chevron');
      btn.textContent = labelText || '';
      if (chevron) {
        btn.appendChild(document.createTextNode(' '));
        btn.appendChild(chevron);
      }
    });
  }

  function initToggle() {
    var allBtns = document.querySelectorAll('[data-tpp-toggle-btn]');
    if (allBtns.length === 0) return;

    // Pro Button-Gruppe: einmal initial verstecken + Click-Handler
    var seenGroups = {};
    allBtns.forEach(function (btn) {
      var group = normalizeGroup(btn.getAttribute('data-tpp-toggle-btn'));
      if (!seenGroups[group]) {
        // Nur verstecken, wenn es Sections in dieser Gruppe gibt
        if (getCollapsiblesForGroup(group).length > 0) {
          setGroupState(group, false);
        }
        seenGroups[group] = true;
      }
      btn.addEventListener('click', function () {
        var nowExpanded = btn.getAttribute('aria-expanded') !== 'true';
        setGroupState(group, nowExpanded);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initToggle);
})();
